import gql from 'graphql-tag';

export const PAGINATION_VIEW_MODEL_FRAGMENT = gql`
  fragment PaginationMetaViewModel on PaginationMeta {
    page
    total
    perPage
    totalPages
  }
`;
